import React, {useEffect, useLayoutEffect, useState} from "react";
import {Divider, Drawer, Grid, List, Tooltip} from "@material-ui/core";
import clsx from "clsx";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import {withRouter} from "react-router-dom";
import {sidebarTabsList} from "../../environment";
import {useStyles} from "./styles";
import {LogoIcon, LogoText, profileImg} from '../../assets/images/images';

import {getUserDataFromLocalStorage} from "../../services/utils";
import {applyAuthHeader} from "../../services/authInterceptor";

const MySidebar = (props) => {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [userData, setUserData] = useState({});
  const [activeTab, setActiveTab] = useState("");
  const [country, setCountry] = useState({})
  const onChangeCountry = (item) => {
    // setCountry(item)
  }
  const _useEffect = () => {
    let userData = getUserDataFromLocalStorage();
    if (userData) {

      // let username = userData?.personal_detail?.full_name
      // username = username.replace(/\b\w/g, l => l.toUpperCase())
      // document.title = username
      setUserData(userData);
      highlightActiveTab();
    }
  };
  const highlightActiveTab = () => {
    let pathname = props.history.location.pathname.split("/");
    let fullPath = props.history.location.pathname;
    let activeTab = pathname[pathname.length - 1];
    // console.log('this is ative ', activeTab)
    if (activeTab) {
      // setActiveTab(activeTab);
      if (fullPath.search('cp') >= 0) {
        // activeTab=
        // props.history.push(`/cp/${activeTab}`);
      }
      // else if (activeTab !== 'dashboard')
      // console.log({activeTab})
      // props.history.push(`/${activeTab}`);
      // }
      // else {
      //     props.history.push('/dashboard')
    }
  };
  useEffect(_useEffect, []);

  const _useEffectActiveTab = () => {
    let pathname = props.history.location.pathname.split("/");
    let fullPath = props.history.location.pathname;
    let activeTab = pathname[1];
    // if (fullPath.search('cp') >= 0) {
    //   activeTab = 'cps'
    //   // activeTab = '/cp/' + pathname[pathname.length - 1]
    //   // props.history.push(`/cp/${activeTab}`);
    // }
    setActiveTab(activeTab);
  };
  useEffect(_useEffectActiveTab, [activeTab]);

  const onLogout = () => {
    localStorage.clear();
    applyAuthHeader(null);

    props.history && props.history.push("/");
    // window.location.reload(false);
  };
  const onTabHandler = (e, tab) => {
    e.preventDefault();
    let tabKey = tab.key.toLowerCase();

    // console.log({tabKey})
    // if (tabKey !== activeTab) {
      // if(tabKey==='cp'){
      //   tabKey='cp/cp-list'
      // }
      // if (tabKey === "login") {
      //   props.history.push({pathname: `/login`});
      // }
      // if (tabKey === "dashboard") {
      //   props.history.replace('/dashboard');
      // } else
      //   {
      props.history.push({pathname: `/${tabKey}`});
      // }
      setActiveTab(tabKey);
    // }
  };

  const handleDrawer = () => {
    setOpen(!open);
  };

  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }

    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  useEffect(() => {
    if (size[0] <= 768) {
      if (open) {
        setOpen(!open);
      }
    } else {
      if (!open) {
        setOpen(!open);
      }
    }
  }, [size])
  return (
    <div>
      {/*<AppBar*/}
      {/*  position="fixed"*/}
      {/*  className={clsx(classes.appBar, {*/}
      {/*    [classes.appBarShift]: open,*/}
      {/*    [classes.appBarShift1]: !open,*/}
      {/*  })}*/}
      {/*>*/}
      {/*  <Toolbar style={{background: 'white', color: 'black', justifyContent: 'space-between'}}>*/}
      {/*    <div className='display-flex pt-10 pb-10' style={{display: 'flex'}}>*/}
      {/*      <h3 className='app-logo-text' style={{display: open ? 'none' : 'inline'}}>cp-rrp</h3>*/}
      {/*    </div>*/}
      {/*    <div className='logout-container'>*/}
      {/*      <img src={userIcon} alt={'profile'} title='Profile' className='cursor-pointer'/>*/}
      {/*      <button className='btn custom-btn btn-3 btn-4' onClick={onLogout} title='Logout'><span>logout</span>*/}
      {/*      </button>*/}
      {/*    </div>*/}
      {/*  </Toolbar>*/}
      {/*</AppBar>*/}

      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div>
          <ListItem style={{marginTop: -10, paddingBottom: 15, paddingLeft: -4}}>
            <Tooltip title={'open/close sidebar '} arrow>
            <ListItemIcon onClick={handleDrawer} className='cursor-pointer'>
              {/*<MenuIcon/>*/}
                {/*<span className="text-capitalize app-logo-text ">cp-rrp</span>*/}
                <img src={LogoIcon} alt={''} width={50}/>
                {open && <img src={LogoText} alt={''} width={90}/>}
              {/*</Tooltip>*/}
            </ListItemIcon>
            </Tooltip>
            <Grid item className='cursor-pointer display-flex align-items-center'>
              <Tooltip title={'go to homepage'} arrow>
                <p onClick={() => props.history.replace('/')}
                   className='premium ml-5 font-12  text-bold text-capitalize'>Home</p>
              </Tooltip>
            </Grid>
          </ListItem>

          <Divider className='bg-white'/>
        </div>
        <div className='sidebar-tab-container'>
          <List style={{paddingRight: 10, borderBottomRightRadius: 40}}>
            {sidebarTabsList.map((obj, index) => {
              let key = obj.key.toLowerCase();
              let [textClass, iconColor] = activeTab == key ? ["active-tab", "white_icon"] : ["sidebar-tab-text", "black_icon"];

              let IconT = obj.icon;
              return (
                <Tooltip title={obj.text} key={`tabList ${index + 1}`} arrow>
                  <ListItem
                    button
                    onClick={(e) => onTabHandler(e, obj)}
                    className={textClass}
                  >
                    <ListItemIcon className='sidebar-tab-icon'>
                      <IconT className={iconColor}/>
                      {/*<img src={obj.icon} className={iconColor} alt={""}/>*/}
                    </ListItemIcon>
                    <ListItemText
                      primary={obj.text}
                      className={`text-capitalize ${open ? 'display-flex' : 'display-none'}`}
                    />
                  </ListItem>
                  {/*<Divider/>*/}
                </Tooltip>
              );
            })}
          </List>
          {/*<div className='sidebar-dropdown'>*/}
          {/*  <InputRow*/}
          {/*    types={[*/}
          {/*      // {value: values.firstName, error: errors.firstName, label: 'country'},*/}
          {/*      // {value: values.lastName, error: errors.lastName, label: 'state',},*/}
          {/*      {*/}
          {/*        type: 'select',*/}
          {/*        value: country?.value,*/}
          {/*        // error: errors.countryId,*/}
          {/*        // label: 'country',*/}
          {/*        id: 'countryId',*/}
          {/*        icon: country?.icon,*/}
          {/*        dropdownList: userCountryOption*/}
          {/*      },*/}
          {/*    ]}*/}
          {/*    onChangeInput={(value, key) => onChangeCountry(value)}*/}
          {/*    numOfInputPerRow={1}*/}

          {/*  />*/}
          {/*</div>*/}
          <div className='display-flex align-items-center mb-20 mt-20'
            // style={{ width: 35, height: 35, borderRadius: '50%',}}
          >
            {userData?.logo && userData.logo != '' ? <img
                style={{width: '100%', height: '100%', borderRadius: '50%'}}
                src={userData.logo} alt={''}/>
              : <img src={profileImg} alt={""}/>
            }
            <span className='pl-10 text-capitalize'>{userData.firstName} {userData.lastName} <br/> <span
              className='font-12 cursor-pointer' onClick={onLogout}>logout</span> </span>
          </div>
        </div>
      </Drawer>
    </div>
  );
};
// const mapStateToProps = (state) => {
//   const {logo} = state.authReducer?.user?.data
//   return {
//     logo
//   };
// };
//
// const mapDispatchToProps = (dispatch) => {
//   return {
//     // logout: () => dispatch(actions.logout()),
//     // logoutSuccess: () => dispatch(actions.logoutSuccess()),
//   };
// };
export default withRouter(MySidebar);
